var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBeatportLogoinline = function SvgBeatportLogoinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 15,
    viewBox: "0 0 25 15"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A8E00F",
    d: "M21.111 8.804C21.111 3.95 17.124 0 12.222 0 7.321 0 3.333 3.95 3.333 8.804c0 2.247.856 4.386 2.41 6.025.209.218.556.23.778.023l.959-.893a.542.542 0 0 0 .025-.769v-.001a6.353 6.353 0 0 1-1.753-4.385c0-3.533 2.903-6.408 6.47-6.408 3.568 0 6.47 2.875 6.47 6.408a6.35 6.35 0 0 1-1.754 4.385l.003.002a.541.541 0 0 0 .026.768l.958.893c.222.206.57.195.779-.024h-.001a8.725 8.725 0 0 0 2.408-6.024"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A8E00F",
    d: "M24.313 8.841c0-1.173-.177-2.33-.527-3.441v-.003l-.003-.004a.539.539 0 0 0-.67-.345l-1.224.379a.533.533 0 0 0-.354.666l-.001.001c.278.886.42 1.81.42 2.747 0 1.656-.451 3.28-1.304 4.697v.001a.531.531 0 0 0 .187.73l1.1.655a.54.54 0 0 0 .737-.183 11.438 11.438 0 0 0 1.64-5.9M3.664 13.538a9.135 9.135 0 0 1-.884-7.443.533.533 0 0 0-.353-.668l-1.226-.38a.538.538 0 0 0-.67.347L.53 5.393a11.46 11.46 0 0 0 1.11 9.348h.002c.153.25.48.33.735.18l1.1-.656a.531.531 0 0 0 .187-.726v-.001z"
  }))));
};
export default SvgBeatportLogoinline;